module.exports = __webpack_public_path__ + "static/media/flecha-hacia-abajo.c421cb32.svg";